export default {
  list: {
    title: "Activities",
    descriptionAdmin: "View and create activities for sellers and hosts",
    descriptionPartner: "Manage your activities, services and offers",
    newActivity: "New Activity",
    loading: "Loading activities...",
    emptyTitle: "No activities found",
    emptyDescription: "You don't have any activities yet.",
    emptyDescriptionAdmin:
      "Create an activity for a seller or host to get started.",
    createFirst: "Create first activity",
    createdToast: "Activity created successfully!",
    errorLoad: "Could not load activities",
    filterAria: "Filter activities",
    filterAll: "All",
    filterVisible: "Visible",
    filterHidden: "Hidden",
    searchPlaceholder: "Search by name or city…",
    noMatchesTitle: "No matching activities",
    noMatchesDescription: "Try another search or show all activities.",
    showAll: "Show all",
  },
  detail: {
    updatedToast: "Activity updated successfully!",
    serviceCategoriesUpdated: "Service categories updated",
    back: "Back to activities",
    goToPartner: "Go to partner",
    staffPanelTitle: "Staff controls",
    adminEditingBanner:
      "You are editing this storefront as staff. Changes apply to the seller's live listing.",
    adminCommissionTitle: "Platform commission",
    adminOnlyBadge: "Staff only",
    adminCommissionHint:
      "Percentage kept by the platform on this activity's bookings. Sellers do not see this section.",
    adminCommissionPercentAria: "Commission percent for this activity",
    adminCommissionPercentInvalid: "Enter a valid percentage.",
    adminCommissionEdit: "Change",
    adminCommissionToastSaved: "Commission updated.",
    adminCategoryTitle: "Activity type",
    adminCategoryHint:
      "Whether this listing is a restaurant, experience, or service. Sellers cannot change this.",
    adminCategoryToastSaved: "Activity type updated.",
    adminSalesAgentTitle: "Sales agent",
    adminSalesAgentEmpty: "Not assigned",
    adminSalesAgentChange: "Change",
    adminSalesAgentAssign: "Assign",
    adminSalesAgentToastSaved: "Sales agent assignment updated.",
    adminSalesAgentPercentInvalid: "Enter a valid commission percentage.",
    adminSalesAgentModalAssignTitle: "Assign sales agent",
    adminSalesAgentModalReassignTitle: "Change sales agent",
    adminPromoTitle: "Promo discount",
    adminPromoActive: "Active",
    adminPromoEnabled: "Promo enabled",
    adminPromoHint:
      "Set the minimum platform margin to keep on this activity. The discount comes entirely from the platform's margin, so every other party is paid as if there were no discount. The actual discount varies per item and per structure.",
    adminPromoMarginMode: "Minimum margin mode",
    adminPromoMarginModeAbsolute: "Fixed amount",
    adminPromoMarginModePercentage: "Percentage of max margin",
    adminPromoMarginValueAbsolute: "Minimum platform margin (€)",
    adminPromoMarginValuePercentage: "Minimum margin (% of max)",
    adminPromoItemColumn: "Item",
    adminPromoPreviewHint:
      "Discounts vary per item and per structure. The figures below are per item across all reachable structures.",
    adminPromoPreviewLoading: "Loading preview data…",
    adminPromoNoItems: "Add catalog items to preview the resulting discounts.",
    adminPromoMaxMargin: "Max margin",
    adminPromoMinDiscount: "Min discount",
    adminPromoMedianDiscount: "Median discount",
    adminPromoMaxDiscount: "Max discount",
    adminPromoOverrideColumn: "Override",
    adminPromoAddOverride: "Override",
    adminPromoRemoveOverride: "Remove override",
    adminPromoSave: "Save promo",
    adminPromoRemove: "Remove promo",
    adminPromoToastSaved: "Promo saved.",
    adminPromoToastRemoved: "Promo removed.",
    headerCommission: "Commission {{percent}}",
    openStaffTab: "Open staff settings",
    adminActiveTitle: "Activity active",
    adminSalesAgentHint: "Agent who brought this activity in and their commission.",
    adminPromoNotConfigured: "Not configured",
    adminPromoPaused: "Paused",
    adminPromoPreviewTitle: "Discount preview per item",
    adminPromoPreviewEmpty: "Enter a valid minimum margin above to calculate the discount for each item.",
    adminPromoPreviewError: "Couldn't calculate the discount preview. Try again in a moment.",
    adminPromoPriceColumn: "Price",
    adminPromoOverrideCount_one: "{{count}} override",
    adminPromoOverrideCount_other: "{{count}} overrides",
    adminCatalogImportTitle: "Import catalog from PDF",
    adminCatalogImportBarHint:
      "Extract items and labels from a PDF (including scans), then review.",
    adminCatalogImportOpen: "Import PDF",
    adminCatalogImportHint:
      "Upload any PDF menu or catalog — digital or scanned. Review labels first, then assign them to items from the dropdown. Labels are saved on the activity when you confirm.",
    adminCatalogImportFileLabel: "PDF only",
    adminCatalogImportDropHint: "Click to choose a PDF",
    adminCatalogImportExtract: "Extract items",
    adminCatalogImportSave: "Save items",
    adminCatalogImportCancel: "Discard",
    adminCatalogImportChooseAnother: "Choose another PDF",
    adminCatalogImportPreviewCount: "{{count}} item(s) to review",
    adminCatalogImportLabelsTitle: "Labels",
    adminCatalogImportLabelsHint:
      "From the PDF and this activity. Rename updates every item that uses the label. Add new ones anytime.",
    adminCatalogImportLabelsEmpty:
      "No labels yet. Add one to assign it to items.",
    adminCatalogImportAddLabelPlaceholder: "New label name",
    adminCatalogImportRemoveLabel: "Remove label",
    adminCatalogImportLabelNameRequired: "Every label needs a name.",
    adminCatalogImportLabelDuplicate: "That label already exists.",
    adminCatalogImportLabelMissing:
      "An item references a label that was removed.",
    adminCatalogImportLabelUntitled: "(untitled)",
    adminCatalogImportName: "Name",
    adminCatalogImportCategory: "Label",
    adminCatalogImportCategoryNone: "No label",
    adminCatalogImportDescription: "Description",
    adminCatalogImportPrice: "Price (€)",
    adminCatalogImportRemoveRow: "Remove item",
    adminCatalogImportPickFile: "Choose a PDF file first.",
    adminCatalogImportEmptyPreview:
      "No items to save. Extract again or discard.",
    adminCatalogImportNameRequired: "Every item needs a name.",
    adminCatalogImportPriceInvalid: "Enter a valid non-negative price.",
    adminCatalogImportTranslatedBanner:
      "Text was translated to {{language}} for review. Detected source: {{source}}.",
    adminCatalogImportToastExtracted:
      "Extracted {{count}} item(s). Review before saving.",
    adminCatalogImportToastSaved: "Added {{count}} item(s) to the catalog.",
    visibilityLabel: "Catalog visibility",
    visibilityHint:
      "On: shown in the catalog when the activity is active. Off: hidden, no new bookings. Save to apply.",
    visibilityToggleAria: "Show or hide this activity in the catalog",
    visibilityLockedHint:
      "Complete your legal profile in Settings before you can make this activity visible.",
    adminActiveHint:
      "Staff-only. When off, partners cannot open this activity and it never appears in the catalog.",
    adminActiveToggleAria: "Activate or deactivate this activity (staff)",
    adminActiveToastSaved: "Activity active status updated.",
    profileIncompleteBanner:
      "Your legal profile is incomplete. This activity cannot appear in the customer catalog until your profile is complete.",
    profileIncompleteModalTitle: "Complete your legal profile",
    profileIncompleteModalMessage:
      "This activity cannot be shown to customers until your legal profile is complete. Go to Settings to fill in the required information, or continue editing and finish your profile later.",
    profileIncompleteModalGoToProfile: "Go to profile",
    profileIncompleteModalLater: "Do it later",
    partnerShareBadge: "{{percent}}% per booking",
    partnerShareHint:
      "Your agreed share of each booking on this activity with Flitrip.",
    untitledActivity: "Untitled activity",
    loading: "Loading activity...",
    notFoundMessage:
      "The requested activity does not exist or you don't have permission to view it.",
    inactiveAdminBanner:
      "This activity is inactive. Partners can see it in their list but cannot open it until you activate it.",
    hiddenBanner:
      "This activity is hidden from the catalog. Turn visibility on and save to show it again.",
    tabs: {
      ariaLabel: "Activity setup sections",
      general: "General",
      generalDesc: "Name, location, and media",
      generalHeading: "General & storefront",
      generalHint:
        "Name and description in every supported language, location, images, and settings. Save profile changes with the bar at the bottom.",
      availability: "Availability",
      availabilityDesc: "Weekly hours and overrides",
      availabilityHeading: "Availability",
      availabilityHint:
        "Set weekly time slots and overrides for holidays or special periods. Changes save immediately.",
      configuration: "Configuration",
      configurationDesc: "Activity settings, menu, and services",
      configurationHeading: "Activity configuration",
      configurationHint:
        "Category-specific settings, menu items, or service catalog. Most changes save immediately when you confirm them.",
      preview: "Preview",
      previewDesc: "Tablet storefront view",
      previewHeading: "Storefront preview",
      previewHint:
        "See how this activity appears on the in-venue tablet. Booking actions are disabled in preview.",
      staff: "Staff",
      staffDesc: "Commission, agent and promo",
      staffHeading: "Staff settings",
      staffHint: "Visible to staff only. Each block saves on its own.",
    },
    preview: {
      title: "Storefront preview",
      disclaimer:
        "This is a read-only preview of the public catalog page. Save profile changes on other tabs before checking updates here.",
      openInNewTab: "Open in new tab",
    },
  },
  detailForm: {
    catalogCopyTitle: "Name & description",
    descriptionTitle: "Description",
    nameTitle: "Name",
    nameLanguageCardAria: "Edit name in {{language}}",
    descriptionPlaceholder:
      "Describe your activity, the services offered, the experiences customers can expect...",
    descriptionHint:
      "Optional while drafting; required in every language before you can make the activity visible",
    descriptionCustomerBanner:
      "Customers see catalog text in their language when name and description are provided in every supported language.",
    descriptionLanguageCardAria: "Edit description in {{language}}",
    autoTranslateHint:
      "Name and description are required in every language (English, Spanish, Italian, German). Fill at least one language, then generate translations. After a rename, generate again to update the other languages.",
    autoTranslateGenerate: "Generate translations",
    locationTitle: "Location",
    handshakeConfigTitle: "Booking confirmation",
    requiresHandshake: "Requires Handshake",
    requiresHandshakeHint:
      "When enabled, bookings require seller confirmation before being finalized. Customers will select a preferred date/time and wait for your approval.",
    noteStrong: "Note:",
    handshakeNote:
      "Services for this activity will use the activity's opening hours for scheduling. Customers can only have one active handshake at a time.",
    handshakeNoteRestaurant:
      "Customers must confirm the booking with you before the reservation fee is charged. Customers can only have one active handshake at a time.",
    bookingCutoffTitle: "Booking cutoff",
    bookingCutoffHint:
      "How long before each start-only slot bookings must close. Slots with an end time stay bookable until that end (cutoff does not apply).",
    bookingCutoffLeadTime: "Lead time",
    bookingCutoffUnitLabel: "Unit",
    bookingCutoffUnitMinutes: "minutes",
    bookingCutoffUnitHours: "hours",
    bookingCutoffExample:
      "Example: a 09:00 slot with 2 hours lead time — booking is open until 07:00; after that it is no longer available.",
  },
  weekdays: {
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday",
  },
  schedule: {
    title: "Availability Schedule",
    weeklyTitle: "Weekly Schedule",
    overridesTitle: "Schedule Overrides",
    addOverride: "Add Override",
    noOverrides: "No overrides. Add one for holidays or special periods.",
    noSlotsClosed: "No slots (closed)",
    addTimeSlot: "Add time slot",
    copyScheduleTitle: "Copy {{day}} schedule",
    pasteScheduleTitle: "Paste {{day}} schedule here",
    deleteOverrideConfirm: "Delete this override?",
    closedBadge: "Closed",
    slotModal: {
      editTitle: "Edit Time Slot",
      addTitle: "Add Time Slot",
      startRequired: "Start time is required",
      startTimeLabel: "Start Time",
      duplicateStartError: "Another slot already uses this start time",
      startOnlyTitle: "Start time",
      startOnlySubtitle: "One clock time",
      startOnlyHint:
        "Guests can book this slot until its start time. If a booking cutoff is set, it closes that many minutes before the start.",
      windowTitle: "Time window",
      windowSubtitle: "Start and end",
      windowHint:
        "Guests can book this slot until the end time. Booking cutoff does not apply.",
      endTimeLabel: "End Time",
      endRequired: "End time is required for a time window",
      endAfterStart: "End time must be after start time",
      overlapWarning:
        "This slot overlaps another time slot. You can still save it.",
      maxCapacityLabel: "Max Capacity (optional)",
      maxCapacityPlaceholder: "Leave empty for unlimited",
      maxCapacityHint: "Maximum number of spots available in this slot",
      mealTypeLabel: "Meal Type (optional)",
      breakfast: "Breakfast",
      lunch: "Lunch",
      dinner: "Dinner",
      aperitif: "Aperitif",
      saveSlot: "Save Changes",
      addSlot: "Add Slot",
    },
    overrideModal: {
      titleAdd: "Add Schedule Override",
      titleEdit: "Edit Override",
      nameLabel: "Name",
      namePlaceholder: "e.g., Christmas holidays",
      from: "From",
      to: "To",
      status: "Status",
      closedDuring: "Closed during this period",
      markClosed: "Mark as closed",
      timeSlots: "Time Slots",
      addSlot: "Add Slot",
      noSlotsHint: "No slots defined. Uses weekly schedule if empty.",
      saveChanges: "Save Changes",
      addOverrideBtn: "Add Override",
      nameDateRequired: "Name and date range are required",
      endAfterStart: "End date must be after start date",
    },
    toast: {
      updated: "Schedule updated",
      updateError: "Error updating schedule",
      overrideCreated: "Override created",
      overrideCreateError: "Error creating override",
      overrideUpdated: "Override updated",
      overrideUpdateError: "Error updating override",
      overrideDeleted: "Override deleted",
      overrideDeleteError: "Error deleting override",
      copiedDay: "Copied {{day}} schedule",
      slotOverlapWarning:
        "This slot overlaps another time slot. It was saved anyway.",
    },
  },
  zod: {
    nameRequired: "Name is required in every language",
    descriptionRequired: "Description is required in every language",
    allTranslationsRequired: "Translations are required in every language",
    commissionPercentRequired: "Platform commission is required",
    commissionPercentRange: "Enter a valid percentage.",
    categoryRequired: "Select a catalog category",
    paymentModelRequired: "Select a payment type",
    bookingCutoffInvalid: "Enter a whole number (0 or greater).",
    bookingCutoffRange:
      "Lead time must be within allowed limits (up to 7 days).",
  },
  card: {
    active: "Active",
    inactive: "Inactive",
    hidden: "Hidden",
    notReadyYet: "Not ready yet",
    inactiveBlocked:
      "This activity is not active yet. Please try again later.",
    partnerShare: "{{percent}}% per booking",
  },
  header: {
    paymentModelUpfront: "Upfront payment",
    paymentModelDeposit: "Deposit",
    paymentModelReceiptBased: "Receipt-based",
  },
  createModal: {
    title: "Create New Activity",
    owner: "Owner",
    regionLabel: "Payment region *",
    chooseRegion: "Select region…",
    regionRequired: "Select a payment region",
    searchOwnerLabel: "Search seller or host",
    searchOwnerPlaceholder: "Type to filter…",
    selectAccount: "Select account *",
    chooseOwner: "Choose owner…",
    noOwnersError: "Add a seller or host first",
    partnerSuffix: "(seller)",
    hostSuffix: "(host)",
    catalogCategory: "Catalog category",
    activityName: "Activity Name",
    description: "Description",
    descriptionPlaceholder: "Describe your activity...",
    location: "Location",
    commissionPercentLabel: "Platform commission rate (%)",
    salesAgent: "Sales agent (contract)",
    salesAgentSearchPlaceholder: "Type an email to search…",
    salesAgentNoResults: "No sales agents match your search.",
    paymentModel: "Payment type",
    paymentModelUpfront: "Upfront payment",
    paymentModelUpfrontDesc: "Customers pay before the visit.",
    paymentModelDeposit: "Deposit at kiosk",
    paymentModelDepositDesc:
      "Customers pay the platform fee at the kiosk; the rest is paid to the partner at the venue.",
    paymentModelReceiptBased: "Receipt-based (restaurant flow)",
    paymentModelReceiptBasedDesc:
      "Restaurant-style flow with receipt upload and cashback.",
    createActivity: "Create Activity",
    wizardNext: "Continue",
    wizardSkip: "Skip",
    wizardStepDetails: "Details",
    wizardStepSalesAgent: "Sales agent",
    wizardStepCounter: "Step {{current}} of {{total}}",
    withoutLocation: "Without location",
    noLocationSelectedMessage: "This activity does not have a location.",
    wizardStep2Lead:
      "Select a sales agent from the list, or skip to continue without one.",
    salesAgentCutPercentLabel: "Sales agent commission (%)",
    salesAgentCutRequired:
      "Enter the sales agent commission when an agent is selected.",
    wizardStep3Lead:
      "Enter an address for geocoding, or mark the activity as having no fixed location.",
    salesAgentListEmpty: "No sales agents available.",
  },
  adminCreate: {
    back: "Back to activities",
    backToPartner: "Back to seller",
    backToHost: "Back to host",
  },
  restaurantConfig: {
    title: "Restaurant Configuration",
    cuisineTypes: "Cuisine Types",
    cuisinePlaceholder: "Select cuisine types…",
    cuisineHint: "Select one or more cuisine types",
    avgPriceLabel: "Avg. Price per Person (€)",
    avgPriceHint: "Average cost per person in euros",
    avgPricePlaceholder: "25",
  },
  serviceCategories: {
    title: "Service Categories",
    addCategory: "Add Category",
    emptyTitle: "No categories yet",
    emptyDescription: "Create categories to organize the services you offer",
    emptyTitleMenu: "Standard courses are ready",
    emptyDescriptionMenu:
      "Appetizer, first course, and the other default courses stay available when adding dishes. Add a category here only if you need an extra grouping.",
    standardCoursesHint:
      "Standard menu courses stay available when adding dishes.",
    edit: "Edit category",
    delete: "Delete category",
    modalEditTitle: "Edit Category",
    modalAddTitle: "Add Category",
    nameLabel: "Category name",
    namePlaceholder: "e.g. Massages",
    saveChanges: "Save Changes",
    allTranslationsRequired: "Name is required in every language",
    fillOneLanguageFirst:
      "Enter the category name in at least one language before generating translations.",
    autoTranslateHint:
      "Category name is required in every language. Fill at least one language, then generate translations. After a rename, generate again to update the other languages.",
    autoTranslateGenerate: "Generate translations",
    thisCategory: "this category",
    deleteConfirm: 'Delete "{{name}}"?',
  },
  media: {
    saveChangesError: "Failed to save media changes",
    uploadedCount: "{{count}} file(s) uploaded",
    deleted: "Media deleted",
    deleteFailed: "Failed to delete file",
    arrowNavHint: "Use arrow keys ← → to navigate",
    prevTitle: "Previous (←)",
    nextTitle: "Next (→)",
    deleteConfirmTitle: "Delete media?",
    deleteConfirmMessage:
      "This file will be removed from the activity. This action cannot be undone.",
    sectionTitle: "Images and Videos",
    autoSaveBadge: "Saves automatically",
    sectionDescription:
      "Upload images and videos that will be shown to customers. Drag thumbnails to reorder.",
    emptyEditableTitle: "Add images or videos",
    emptyEditableHint: "Click to select files",
    emptyReadOnly: "No media available",
    thumbnailAlt: "Thumbnail {{n}}",
    uploadingAlt: "Uploading {{n}}",
    cropDescription:
      "Frame the photo for the tablet gallery (16:9). The dashed center shows what home cards keep (4:3).",
  },
} as const;
